// extracted by mini-css-extract-plugin
module.exports = {"Quiz":"Quiz_Quiz__1489A","QuizWrapper":"Quiz_QuizWrapper__MOHSH"};